import React, { useState } from 'react';
import { TenantBranding } from '../types';

interface PassphrasePromptProps {
  displayName: string;
  branding: TenantBranding;
  onVerified: (token: string) => void;
  verifyPassphrase: (passphrase: string) => Promise<string>;
}

const PassphrasePrompt: React.FC<PassphrasePromptProps> = ({ displayName, branding, onVerified, verifyPassphrase }) => {
  const [passphrase, setPassphrase] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const token = await verifyPassphrase(passphrase);
      onVerified(token);
    } catch {
      setError('Incorrect passphrase. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="passphrase-overlay">
      <div className="passphrase-box">
        {branding.headerLogoUrl && (
          <img src={branding.headerLogoUrl} alt={displayName} className="passphrase-logo" />
        )}
        <h2 className="passphrase-title">{displayName}</h2>
        <p className="passphrase-message">This dashboard is password protected. Please enter the passphrase to continue.</p>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            className="passphrase-input"
            value={passphrase}
            onChange={(e) => setPassphrase(e.target.value)}
            placeholder="Enter passphrase"
            autoFocus
            disabled={submitting}
          />
          {error && <p className="passphrase-error">{error}</p>}
          <button type="submit" className="passphrase-button" disabled={submitting || !passphrase}>
            {submitting ? 'Verifying...' : 'Continue'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PassphrasePrompt;
